import defaultAttributes from '../defaultAttributes';

const Activity = [
  'svg',
  defaultAttributes,
  [['polyline', { points: '22 12 18 12 15 21 9 3 6 12 2 12' }]],
];

export default Activity;
